import './styles.sass';
import "./styles/prism.css";
import "./styles/google-sso.css";

import jQuery from 'jquery';
import VueTour from '@/components/dashboard/guides/main'

window['jQuery'] = jQuery;
import Vue from 'vue';
import Log from "@/utils/Log";
import HomePage from '@/HomePage';
import setupCompatibilityHooks from "@/utils/Compatibility";
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue';

import VueRouter from 'vue-router';
import SessionManager from '@/utils/SessionManager';

import '../node_modules/pintura/pintura.css';

import Dashboard from "@/components/dashboard/Dashboard";
import {FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome';
import fontAwesomeSetup, {FontAwesomeIconWrapper} from "@/FontAwesomeSetup";

import Rpc from "@/Rpc";
import moment from 'moment-timezone';
import PortalVue from 'portal-vue';
import {EventBusPlugin} from "@/utils/EventBusPlugin";
import BigDecimal from "@/server/BigDecimal";
import {CordovaSessionPlugin} from "@/utils/CordovaSessionPlugin";
import tr from "@/utils/Tr";

tr();

window["Rpc"] = Rpc;
window["moment"] = moment;
window["BigDecimal"] = BigDecimal;

setupCompatibilityHooks();
fontAwesomeSetup();

Vue.use(EventBusPlugin);
Vue.use(CordovaSessionPlugin);
Vue.use(PortalVue)
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueRouter);
Vue.use(AppTrPlugin);



Vue.use(VueTour)
Vue.component('font-awesome-icon', FontAwesomeIconWrapper);
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.component('MaintenanceView', MaintenanceView);

import 'highlight.js/styles/github.css';

import setupWsPipe, {WsPipe} from "@/utils/WsPipe";
import RpcException from "@/server/com/silkplm/engine/rpc/exceptions/RpcException";
import DialogManager from "@/utils/DialogManager";
import ForgotPassword from "@/components/ForgotPassword";
import ResetPassword from "@/components/ResetPassword";
import {setupTestHelpers} from "@/utils/TestHelpers";
import {stringFormatSetup} from "@/components/forms/StringFormat";
import {initRenderers} from "@/components/forms/renderers/Renderers";
import {initMixins} from "@/components/forms/mixins/Mixins";
import RpcClass from "@/server/RpcClass";
import fixCookies from "@/mobile/MobileCookies";
import {checkInvite, checkPreConf} from "@/invitations/invites";
import AppTranslations from "@/utils/AppTranslations";
import {AppTrPlugin} from "@/utils/AppTrPlugin";
import MaintenanceView from "@/components/notifications/MaintenanceView.vue";
import {checkPreselectedPlan, resetEndpoint, restoreLastLoginServer} from "@/components/subscriptions/Subs";

// hljs.registerLanguage('lua', lua);
// hljs.registerLanguage('javascript', js);
// hljs.registerLanguage('json', js);


const nextURL = window.location.origin + "/dashboard/";
const nextTitle = 'SilkPLM';
const nextState = {stateId: 0};

const url = new URL(window.location.href);
if(url.searchParams.has("clearLocalStorage")){
    console.log("clearLocalStorage");
    localStorage.clear();
}


AppTranslations.checkUrlForLanguage();
checkPreConf();
checkInvite();
checkPreselectedPlan();

let isForgotPassword = window.location.pathname.includes("forgot-password");
let isResetPassword = window.location.pathname.includes("reset-password");

if (!isForgotPassword && !isResetPassword) {
    window.history.replaceState(nextState, nextTitle, nextURL);
}

function setupRouter() {
    return new VueRouter({
        mode: 'history',
        base: '/dashboard',
        routes: [
            {
                path: "/forgot-password",
                component: ForgotPassword,
                name: "ForgotPassword"
            },
            {
                path: "/reset-password",
                component: ResetPassword,
                props: route => ({token: route.query.token}),
                name: "ResetPassword"
            },
            {
                path: "/(.*)?",
                component: Dashboard, props: true,
                name: "Dashboard"
            },

        ]
    })
}

async function bootstrap() {
    stringFormatSetup();

    await AppTranslations.setup();
    Vue.config.productionTip = false
    Vue.config.errorHandler = function (err, vm, info) {
        Log.fatal(`Error: ${err.toString()}\nInfo: ${info}`, true);
        if (err instanceof RpcException) {
            DialogManager.errorNotification(err).then();
        } else
            throw err;
    }

    Vue.config.warnHandler = function (msg, vm, trace) {
        Log.fatal(`Warn: ${msg}\nInfo: ${trace}`, true);
        console.error(`[Vue warn]: ${msg}${trace}`)
    }

    await initRenderers();
    await initMixins();

    try {
        restoreLastLoginServer();
        let userData
        try {
            userData = await Rpc.Session.userInfo();
        } catch (e){
            resetEndpoint();
            userData = await Rpc.Session.userInfo();
        }

        if (userData.isAdmin) {
            await SessionManager.initialize(true, userData);
        } else {
            await SessionManager.initialize(false, userData);
        }
    } catch (e) {
        Log.debug(e);
        console.error(e);
        setTimeout(() => bootstrap(), 2000)
        return;
    }

    let router = setupRouter();
    SessionManager.setRouter(router);
    document.getElementById("load-progress").remove();
    new Vue({
        router: router,
        render: h => h(HomePage)
    }).$mount('#mainContent')

}

if (!window["isCordova"]) {
    setupWsPipe();
    bootstrap().then(() => {
        Log.info('Bootstrapped!')
    });

    setupTestHelpers();
} else {
    window.cordovaUrl = window.localStorage.getItem('cordovaURL');
    if (window.cordovaUrl === null)
        window.cordovaUrl = "https://silkplm.com"

    // console.log("************************************************************")
    // console.log(window.cordovaUrl)
    // console.log("************************************************************")
    RpcClass.baseAddress = window.cordovaUrl;
    WsPipe.PUSH_SOCKET_ADDR = "wss://" + window.cordovaUrl.split('//')[1];
    // console.log("Cordova detected");
    document.addEventListener('deviceready', onDeviceReady, false);
}

function onDeviceReady() {
    // Cordova is now initialized. Have fun!
    fixCookies();
    setupWsPipe();
    bootstrap().then(() => {
        Log.info('Bootstrapped!')
    });

    setupTestHelpers();
}

